<template>
  <div>
    <w-tool-tabs class="tab-button" size="mini" v-model="activeTab">
      <el-tab-pane :label="kedbLabel" name="kedbList">
        <el-table-wrapper ref="kedbTable" :data="kedbData" :columns="kedbColumns" :pagination="true" :total="kedbTotal"
         :show-custom-header="false" :show-search-tool="false" style="width:100%;" :column-default="columnDefault">
         <template slot-scope="scope" slot="kedb-title-slot">
           <span class="link c-pointer" @click="changeKedbDetailView(scope.row)">{{scope.row.title}}</span>
         </template>
       </el-table-wrapper>
      </el-tab-pane>
      <el-tab-pane :label="troubleTicketLabel" name="troubleTicketList">
        <el-table-wrapper ref="relationTroubleTable" :data="relationTroubleList" :columns="relationTroubleColumns" :total="troubleListTotal"
         :show-custom-header="false" :show-search-tool="false" style="width:100%;" :pagination="true" :column-default="columnDefault">
         <template slot-scope="scope" slot="trouble-ticket-group-id-slot">
           <span class="link c-pointer" @click="clickTroubleTicketGroupId(scope.row.troubleTicketGroupId)">{{scope.row.subject}}</span>
         </template>
        </el-table-wrapper>
      </el-tab-pane>
    </w-tool-tabs>
    <w-kedb-detail-popup ref="detailPopup" viewType="relationKedbPopup" :params="datailPopupInfo" />
    <w-event-ticket-status-popup ref="statusPopup" :isReadOnlyTicket="true" :trouble-ticket-info="troubleTicketInfo"></w-event-ticket-status-popup>
  </div>
</template>

<script>
import { isNil, isEqual, isEmpty } from 'lodash';
import msgUtil from '@/utils/message';
import { getDateToString } from '@/utils/date';
import { EMPTY_TEXT } from '@/utils/string';
import { columnDefault } from '@/constants/table';
import KedbAPI from '@/api/event/kedb';
import WKedbDetailPopup from '@/views/event/kedb/components/popup/KedbDetailPopup';

const getTroubleStatus = (row, column, value) => (isEqual(value, 'R') ? '처리 중' : '처리 완료');
const getDateFormatter = (row, column, value) => (!isNil(value) ? getDateToString(value) : EMPTY_TEXT);
const checkEmptyValue = (row, column, value) => (!isNil(value) ? value : EMPTY_TEXT);

export default {
  name: 'WRecommendHandlingTroubleView',
  components: {
    WKedbDetailPopup,
    WEventTicketStatusPopup: () => import('@/views/event/components/popup/EventTicketStatusPopup'),
  },
  props: {
    targetEventInfo: {
      type: Object,
      default: () => {},
    },
    searchkeyword: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      columnDefault,
      activeTab: 'kedbList',
      kedbLabel: 'KEDB',
      troubleTicketLabel: '장애티켓',
      troubleListTotal: 0,
      relationTroubleList: [],
      relationTroubleColumns: [
        { prop: 'troubleTicketGroupId', width: '55px', label: 'No' },
        { prop: 'subject', scopedSlot: 'trouble-ticket-group-id-slot', label: '장애티켓 제목' },
        { prop: 'writerId', label: '발행자', width: '130px' },
        { prop: 'lastEditerId', label: '처리자', width: '130px' },
        { prop: 'writeDatetime', label: '발행일시', width: '130px', formatter: getDateFormatter },
        { prop: 'lastEditDatetime', label: '처리일시', width: '130px', formatter: getDateFormatter },
        { prop: 'troubleStatus', label: '처리현황', width: '90px', formatter: getTroubleStatus },
      ],
      kedbTotal: 0,
      kedbData: [],
      kedbColumns: [
        { prop: 'seqNumber', label: 'No', width: 55 },
        { prop: 'title', label: '제목', scopedSlot: 'kedb-title-slot' },
        { prop: 'writerId', label: '작성자', width: '130px' },
        { prop: 'writeDatetime', label: '작성일시', width: '130px', formatter: getDateFormatter },
        { prop: 'recommendCount', label: '추천수', width: '70px', align: 'center', headerAlign: 'center' },
        { prop: 'viewCount', label: '조회수', width: '70px', formatter: checkEmptyValue, align: 'center', headerAlign: 'center' },
      ],
      datailPopupInfo: null,
      troubleTicketInfo: null,
    };
  },
  watch: {
    targetEventInfo: {
      handler() {
        this.loadData();
      },
    },
  },
  methods: {
    clear() {
      this.kedbLabel = 'KEDB';
      this.troubleTicketLabel = '장애티켓';
      this.activeTab = 'kedbList';
    },
    loadData() {
      if (!isEmpty(this.targetEventInfo)) {
        this.$emit('change-load-mask', true);
        const param = {
          managetypeId: this.targetEventInfo.managetypeId,
          rsctypeId: this.targetEventInfo.rsctypeId,
          rscId: this.targetEventInfo.rscId,
          rscKey: this.targetEventInfo.rscKey,
          eventlevelId: this.targetEventInfo.eventlevelId,
          searchKeyword: this.searchkeyword,
        };
        KedbAPI.getRecommendTroubleshooting(param).then((response) => {
          const result = response.data;
          if (result.success) {
            this.kedbData = result.data.kedb;
            this.kedbTotal = result.data.kedb.length;
            this.kedbLabel = `KEDB (${this.kedbTotal})`;
            // 추천 KEDB 목록이 존재하지 않는 경우 장애티켓 탭을 선택하도록 처리
            if (this.kedbTotal === 0) {
              this.activeTab = 'troubleTicketList';
            } else {
              this.activeTab = 'kedbList';
            }
            this.relationTroubleList = result.data.troubleshooting;
            this.troubleListTotal = result.data.troubleshooting.length;
            this.troubleTicketLabel = `장애티켓 (${this.troubleListTotal})`;

            this.$emit('complete-load', result.data);
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '장애 조치 추천', false));
          }
        }).catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '장애 조치 추천', false));
          throw new Error(e);
        }).finally(() => {
          this.$emit('change-load-mask', false);
        });
      }
    },
    /**
     * Kedb 상세 팝업을 연다
     * @author yelim
     */
    changeKedbDetailView(row) {
      this.datailPopupInfo = {
        seqNumber: row.seqNumber,
      };
      this.$refs.detailPopup.open();
    },
    /**
     * 장애 티켓 타이틀 클릭 이벤트 핸들러
     * @author yelim
     * @param  {[type]} troubleTicketGroupId [description]
     */
    clickTroubleTicketGroupId(troubleTicketGroupId) {
      this.troubleTicketInfo = { troubleTicketGroupId };
      this.$refs.statusPopup.open();
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/popup/FaultAnalysisPopup/components/RecommendHandlingTroubleView.vue